import { SummaryRow, CancelledIcon } from "@components";

import { formatAmount } from "@utils";
import { useOutletContext } from "react-router-dom";

const PRCancelled = () => {
  const { amountRequested, merchant, reference } = useOutletContext();

  return (
    <div className="bg-zinc-100 h-dvh grow lg:h-full">
      <div className="w-full  lg:w-[480px] mx-auto flex flex-col items-center">
        <div className="size-[160px] mx-auto flex items-center justify-center mt-10">
          <CancelledIcon />
        </div>
        <h1 className="font-semibold text-xl mb-2">Cancelled</h1>
        <p className="text-zinc-500 text-center mb-5">
          This payment request has been cancelled
        </p>
        <div className="w-full px-8 py-5">
          <div className="bg-white rounded-xl border border-zinc-300 w-full">
            {amountRequested && (
              <SummaryRow
                pad
                label="Amount"
                value={formatAmount(amountRequested)}
              />
            )}
            <SummaryRow pad label="Recipient" value={merchant?.name} />
            <SummaryRow isLast pad label="Reference" value={reference} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PRCancelled;
